import { Helmet } from 'react-helmet';
import RegisterSignUpStepForm from './RegisterSignUpStepForm/RegisterSignUpStepForm';

export default () => {
  return (
    <>
      <Helmet>
        <title>Inscription</title>
      </Helmet>
      <RegisterSignUpStepForm />
    </>
  );
};
